import React, { useState, useRef } from "react";
import { Button, Dialog, DialogContent, DialogActions } from "@mui/material";
import { Html5QrcodeScanner } from "html5-qrcode";

export default function QrScannerButton({ onDecodeText }) {
  const [open, setOpen] = useState(false);
  const scannerRef = useRef(null);

  const startScanner = () => {
    if (!scannerRef.current) {
      scannerRef.current = new Html5QrcodeScanner("reader", {
        fps: 10,
        qrbox: { width: 250, height: 250 },
      });
    }

    try {
      scannerRef.current.render(
        (decodedText) => {
          console.log("Scanned QR Code:", decodedText);

          // Call your custom method if passed
          if (typeof onDecodeText === "function") {
            onDecodeText(decodedText);
          }

          stopScanner();
          setOpen(false);
        },
        (error) => {
          console.warn("Scan error:", error);
        }
      );
    } catch (err) {
      console.error("Scanner render failed:", err);
    }
  };

  const stopScanner = () => {
    if (scannerRef.current) {
      scannerRef.current
        .clear()
        .catch((error) => console.warn("Failed to clear scanner", error));
      scannerRef.current = null;
    }
  };

  const handleOpen = () => {
    setOpen(true);
    setTimeout(startScanner, 200); // delay so dialog is mounted
  };

  const handleClose = () => {
    stopScanner();
    setOpen(false);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <Button
        variant="contained"
        onClick={handleOpen}
        style={{ color: "white", width: "100%", backgroundColor: "brown" }}
      >
        Direct Scan Exam QR Code
      </Button>

      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogContent>
          <div id="reader" style={{ width: "100%" }}></div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
